import { type IconProps, iconVariants } from '@/components/icons/common'
import { cn } from '@/utils/cn'

export function ShieldIcon({ className, size = 24, ...props }: IconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      color="currentColor"
      className={cn(iconVariants({ size, className }))}
      {...props}
    >
      <path
        d="M5.29775 4.51335L11.2978 2.26334C11.7505 2.09355 12.2495 2.09355 12.7023 2.26334L18.7023 4.51334C19.4829 4.80607 20 5.55216 20 6.38585V12C20 15.9394 15.0339 19.2581 12.9271 20.4887C12.3538 20.8236 11.6561 20.807 11.0961 20.4503C9.00282 19.1171 4.00002 15.5586 4 12L4 6.38584C4 5.55215 4.51715 4.80607 5.29775 4.51335Z"
        fill="currentColor"
      />
    </svg>
  )
}
